import { Car, CarManagement, Key, Percent } from '@/media/icons';

import { ROUTES, WEBVIEW_ROUTES } from '../routes';

type TIconComponent = React.FC<React.SVGProps<SVGSVGElement>>;

export interface IWebviewService {
  id: string;
  /** Маршрут оболочки сервиса (без ведущего слеша). */
  route: string;
  Icon: TIconComponent;
  /** CSS-токен фона иконки. */
  color: string;
}

/**
 * Доступные webview-сервисы веб-оболочки (паритет с реестром нативки — только то, что есть
 * в вебе). Единый источник для лаунчера Services и быстрых ссылок на Home. Тексты — i18n:
 * `serviceTitles.${id}` / `serviceSubtitles.${id}`.
 */
export const WEBVIEW_SERVICES: IWebviewService[] = [
  {
    id: 'auto-credit',
    route: WEBVIEW_ROUTES.autoCredit,
    Icon: Car,
    color: 'rgb(244, 122, 31)'
  },
  {
    id: 'pre-approval',
    route: ROUTES.preApproval,
    Icon: Percent,
    color: 'rgb(23, 111, 189)'
  },
  {
    id: 'leasing',
    route: WEBVIEW_ROUTES.leasing,
    Icon: Key,
    color: 'rgb(31, 184, 122)'
  },
  {
    id: 'vehicle-management',
    route: WEBVIEW_ROUTES.vehicleManagement,
    Icon: CarManagement,
    color: 'rgb(124, 92, 255)'
  }
];

export const AUTO_CREDIT_CITY_STORAGE_KEY = 'moni-auto-credit-city';
